var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({
    arrow: true,
    theme: _vm.error && _vm.status != 'RUNNING' ? 'red' : 'green',
  }),expression:"{\n    arrow: true,\n    theme: error && status != 'RUNNING' ? 'red' : 'green',\n  }"}],staticClass:"relative flex w-3 items-center justify-center",attrs:{"content":_vm.status != 'RUNNING' && !_vm.error
      ? 'Investimento parado'
      : _vm.error && _vm.status != 'RUNNING'
      ? 'Error, verifique o parâmetro abaixo'
      : 'Investimento em execução'}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status == 'RUNNING'),expression:"status == 'RUNNING'"}],staticClass:"bg-ontick-green-600 h-3 w-3 rounded-full",class:{
      'animate-ping': _vm.position !== 'Zerado',
    }}),_c('span',{staticClass:"absolute h-3 w-3 rounded-full",class:_vm.status === 'RUNNING' ? 'bg-ontick-green-600 ' : ' bg-gray-500 '})])
}
var staticRenderFns = []

export { render, staticRenderFns }